import { useMutation, useQueryClient } from "@tanstack/react-query";
import TeamService from "../../../services/TeamService";
import { useToastAlert } from "../../../components/app/ToastAlert/ToastAlertProvider";
import {
  TEAM_INVITED_COACHES_QUERY_KEY,
  TEAM_PENDING_COACHES_COUNT_QUERY_KEY,
} from "./CoachTeamRoute";

export default function useRevokeCoachInviteMutation() {
  const queryClient = useQueryClient();
  const { showToastAlert } = useToastAlert();

  return useMutation({
    mutationFn: (inviteId: number) => TeamService.revokeCoachInvite(inviteId),
    onSuccess: () => {
      showToastAlert("success", { message: "Invite revoked" });
      queryClient.invalidateQueries({
        queryKey: [TEAM_INVITED_COACHES_QUERY_KEY],
      });
      queryClient.setQueryData<number>(
        [TEAM_PENDING_COACHES_COUNT_QUERY_KEY],
        (oldCount) => (oldCount ? oldCount - 1 : 0),
      );
    },
    onError: () => {
      showToastAlert("error", { message: "Failed to revoke invite" });
    },
  });
}
